export default "__VITE_ASSET__D2eog8r5__"